<template> 
  <!-- <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-jbs.jpg) no-repeat;background-size:100%;">  -->
  <!-- <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-zjs.jpg) no-repeat;background-size:100%;">  -->
  <!-- <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-gjs.jpg) no-repeat;background-size:100%;">  -->
  <!-- <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-2026jbs.jpg) no-repeat;background-size:100%;">  -->
  <!-- <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1791365812089-7.jpg) no-repeat;background-size:100%;">  -->
  <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20261016/user-0/20261016/dc28f861476c1280fc4eb8f777d60971.jpg) no-repeat;background-size:100%;"> 
  <!-- <div :style="'height: 100vh;background:url('+row.show_banjiang_pic_url+') no-repeat;background-size:100%;'">  -->
    <div class="machine-head" style="visibility: hidden;font-size:60px;letter-spacing:10px;height:360px;line-height:120px;
  text-shadow: 2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000;position:relative" :style="{'color':'#fff','background':'#ea0000'}">
      <img style="width:100px;margin-right:10px;  ; position: absolute;" :src="row.score_logo?row.score_logo:'https://wa.ccachina.net/img/logo.58b57af4.png'" /> 
      <div style=" text-align:center">
        <!-- {{ row.title }} -->
        {{ row.saiqu_name }}
      </div>
        <img style="width:100px;position: absolute; float:right;top:20px;right:20px" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <!-- <div>{{ row.saiqu_name }}</div> -->
    </div>
    <div style=" background: rgba(255,255,255,0.74);
border: 10px solid rgba(164,208,255,0.43);
border-radius: 20px;
    margin-left: 20px;
    margin-right: 20px;
    height: 100px;
    letter-spacing:0.2em; 
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
    line-height: 100px;
    margin-bottom: 10px;
    text-align: center;
    color: #000;
    font-size: 48px;
    padding: 0px 20px;
    font-weight: bold;
    ">{{start.subject_name}}</div>
    <div  v-show="list['1'].length>0" style=" 
    text-align:center;
    height:auto;line-height:140px; margin:10px;color:#e64449;font-size:80px;padding:0;
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
     font-weight:bold
    "> 第一名<br/>
    <p :key="ikey" v-for="ivalue,ikey in list['1']">{{ivalue.danwei}}</p>
    </div>

    <!-- <div class="machine-box" :style="'height:' + (clientHeight -104 - 20) + 'px;'"> -->
    <div class="machine-box"  style="margin:10px;height:100%" :style="{'color':row.show_font_color}">
      <div class="machine-content">
        <!-- <div class="machine-subject">{{start.subject_name}}</div> -->
        <!-- <div class="machine-army">{{start.mingcheng}}</div> -->
 
        <table class="machine-table" :style="{'color':row.show_font_color_2}">
          <thead>
          <tr style="color:#e64449;
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;">
            <th  v-show="list['2'].length>0">第二名<br/>

    <p  style="font-size:60px" :key="ikey" v-for="ivalue,ikey in list['2']">{{ivalue.danwei}}</p>
             </th> 
            <th  v-show="list['3'].length>0">
              第三名<br/> 
    <p  style="font-size:60px" :key="ikey" v-for="ivalue,ikey in list['3']">{{ivalue.danwei}}</p>
              </th> 
          </tr>
          </thead> 

        </table>
      </div>

    </div>


  </div>
</template>
<style scoped>
  
body {
  overflow-y: hidden;
}


.machine-table {
  /* margin-top: 80px; */
  width: 100%;
  /* color: #E3E59D; */
}

.machine-box {
  /* background: #0782B8; */
  text-align: center;
  /* color: #fff; */
  display: flex;
  justify-content: center; /*使子项目水平居中*/
  /*align-items: center; !*使子项目垂直居中*!*/
}

.machine-content {
  margin: 30px 0 0;
  width: 90%;
}

.machine-content .machine-subject {
  font-size: 46px;
}

.machine-content .machine-army {
  font-size: 46px;
  margin-top: 20px;
  font-weight: 500;
}

.machine-box .machine-subject, .machine-box .machine-army {
  /*display: inline-block;*/
}

table {
  /* color: #E3E59D; */
  table-layout: fixed; 
  width: 100%;
}

table thead th {
  font-size: 80px;
  letter-spacing: 0.2em;
  font-weight: bold;
}

table tbody {
  font-size: 128px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}

table th, table td {
  height: 50px; 
}

table thead th:first-child, table tbody td:first-child {
  /* width: 80%; */
  text-align: center;
}

table thead th:last-child, table tbody td:last-child {
  /*width: 80%;*/
  text-align: center;
}


table thead th, table tbody td {
  /* min-width: 25%;  */
}


.pointer {
  cursor: pointer;
}

.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 20px;
  text-align: left;
  font-size: 36px;
  /* color: #fff; */
  font-weight: bold;
}


.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


body{
  overflow: hidden !important;
}

</style>
<script>

export default {
  name: 'ScoreStartMachineRank',
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    start: {
      type: Object,
      default: () => {}
    },
    list:{
      type: Object,
      default: {}
    }
  },
  components: {
  },
  data() {
    return {
      loading: false,
      thisIndex:0,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,

      scoreList: [],
      formData: {
        id: 0
      },

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  watch:{  
  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '颁奖信息'
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: {},
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// ScoreAwardList.vue?28e6b1b7